import axios from "axios";
import { applySkipCache } from "./skipCacheParam";

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * asset-metadata-service client for the Administration tab.
 *
 * Identical to the shared `apiClient` except that every GET carries
 * `_skip_cache=true`. The service fronts its read endpoints (/assets/,
 * /company/, /participant/, /resources/, /ref-data/*, ...) with a Redis
 * request/response cache that writes do not invalidate, so an admin who saves a
 * record and immediately re-reads the list is otherwise shown the pre-write
 * payload for the rest of the TTL. Admin screens are the one place that reads
 * its own writes, which is what the service added the escape hatch for.
 *
 * The bypass is pure on the service side: it neither reads nor refreshes the
 * shared entry, so other tabs keep being served normally and nothing here
 * re-warms a stale key.
 *
 * Kept as its own instance rather than an interceptor on `apiClient` so only the
 * Administration tab pays the cache miss -- the asset dashboard and the other
 * read-only tabs share `apiClient` and should stay cached.
 */
const apiClientAdmin = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClientAdmin.interceptors.request.use(applySkipCache);

export default apiClientAdmin;
